import { Link, HStack, Text } from "@chakra-ui/react";

export default function Header() {
	return (
		<HStack position="sticky" justify="center" p={8} borderRadius="full">
			<Link href="/">
				<Text fontSize="2xl" fontWeight="semibold">
					Retain
				</Text>
			</Link>
		</HStack>
	);
}
